import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import MenuIcon from "@mui/icons-material/Menu";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import WorkIcon from "@mui/icons-material/Work";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import BarChartIcon from "@mui/icons-material/BarChart";
import WbSunnyIcon from "@mui/icons-material/WbSunny";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import DiningIcon from "@mui/icons-material/Dining";
import LogoutIcon from "@mui/icons-material/Logout";
import SettingsIcon from "@mui/icons-material/Settings";
import PhoneIcon from "@mui/icons-material/Phone";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
// import authService from "../../services/authService";
// import { useAuthActions } from "../../contexts/AuthContexts";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
// import userApi from "../../api/userApi";
import "./navbar.css";
import {
	Avatar,
	Divider,
	IconButton,
	ListItemIcon,
	Toolbar,
	Tooltip,
} from "@mui/material";
import {
	Description,
	FolderCopy,
	Image,
	LocalHospital,
	Logout,
	PersonAdd,
	Settings,
	Upload,
	Vaccines,
} from "@mui/icons-material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faRightFromBracket,
	faRightToBracket,
} from "@fortawesome/free-solid-svg-icons";
import { useAuth } from "react-oidc-context";
import { LoadingButton } from "@mui/lab";

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { setLoading } from "../../App";

const NavBar = () => {
	const auth = useAuth();
	const [anchorEl, setAnchorEl] = React.useState(null);
	const open = Boolean(anchorEl);
	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const logoutRedirectUri =
		process.env.NODE_ENV === "production"
			? "https://muktibd.com"
			: "http://localhost:3000";

	const signOutRedirect = () => {
		localStorage.removeItem("auth_user");
		auth.removeUser();
		const clientId = "5kg0lkt0g05v69n84bqhvv6m3j";
		const logoutUri = logoutRedirectUri;
		const cognitoDomain =
			"https://us-east-1qq0n6g838.auth.us-east-1.amazoncognito.com";
		window.location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(
			logoutUri
		)}`;
	};

	const token = localStorage.getItem("token");
	const navigate = useNavigate();
	let decoded = null;
	if (typeof token === "string" && token.trim() !== "") {
		try {
			decoded = jwtDecode(token);
		} catch (error) {
			console.error("Failed to decode token:", error);
		}
	} else {
		console.log("still having issue!");
	}
	const role = decoded?.role || "";
	console.log("role in navbar", role);

	const [state, setState] = useState(false);
	const [theme, setTheme] = useState("light");
	const [user, setUser] = useState(null);
	// const { logout } = useAuthActions();

	if (localStorage.getItem("theme") === null) {
		localStorage.setItem("theme", "light");
	}
	const [tooltipOpen, setTooltipOpen] = useState(true);

	useEffect(() => {
		const closeTooltipOnActivity = () => {
			setTooltipOpen(false);
		};

		// Event listeners for various user activities
		window.addEventListener("click", closeTooltipOnActivity);
		window.addEventListener("keydown", closeTooltipOnActivity);
		window.addEventListener("scroll", closeTooltipOnActivity);
		// window.addEventListener("mousemove", closeTooltipOnActivity);

		// Clean up event listeners
		return () => {
			window.removeEventListener("click", closeTooltipOnActivity);
			window.removeEventListener("keydown", closeTooltipOnActivity);
			window.removeEventListener("scroll", closeTooltipOnActivity);
			// window.removeEventListener("mousemove", closeTooltipOnActivity);
		};
	}, []);

	const location = useLocation();

	// const fetchUser = async () => {
	// 	const result = await userApi.getProfile();
	// 	console.log(result.data);
	// 	if (result.success) {
	// 		setUser(result.data);
	// 	} else {
	// 		console.log("Invalid User");
	// 		logout();
	// 	}
	// };

	// useEffect(() => {
	// 	fetchUser();
	// }, []);

	// useEffect(() => {
	// 	setTheme(localStorage.getItem("theme"));
	// 	if (theme === "dark") {
	// 		document.documentElement.classList.add("dark");
	// 	} else {
	// 		document.documentElement.classList.remove("dark");
	// 	}
	// 	toggleTheme();
	// }, [theme]);

	// const handleLogout = async () => {
	// 	const result = await authService.logout();
	// 	if (result.success) {
	// 		logout();
	// 	} else {
	// 		console.log(result.data);
	// 	}
	// };
	// console.log("auth", JSON.stringify(auth.user));
	// console.log("auth from localstorage", localStorage.getItem("auth_user"));
	// const auth_user = localStorage.getItem("auth_user");
	if (auth.isAuthenticated) {
		localStorage.setItem("auth_user", JSON.stringify(auth.user));
	}
	const handleTheme = () => {
		const localTheme = localStorage.getItem("theme");
		const newTheme = localTheme === "light" ? "dark" : "light";
		localStorage.setItem("theme", newTheme);
		setTheme(newTheme);
	};

	const toggleDrawer = (anchor, open) => (event) => {
		setState({ ...state, [anchor]: open });
	};

	const list = (anchor) => (
		<Box
			sx={{ width: anchor === "top" ? "auto" : 250 }}
			role="presentation"
			onClick={toggleDrawer(anchor, false)}
			onKeyDown={toggleDrawer(anchor, false)}
		>
			<div className="sidebar relative top-0 bottom-0 left-0 h-screen w-full overflow-hidden ">
				<div className="logo flex flex-row justify-center items-center h-1/6 gap-2">
					<LocalHospital fontSize="large" />
					<div className="logo text-3xl dark:text-white alkatra-700">
						মুক্তি
					</div>
				</div>
				<div className="links flex-col ">
					<Link
						className={`link flex items-center rounded-sm text-xl ${
							location.pathname === "/"
								? "bg-slate-200 dark:bg-black"
								: ""
						} hover:bg-slate-300 dark:hover:bg-black`}
						to="/"
					>
						<Vaccines
							className="dark:fill-white"
							fontSize="medium"
						/>
						<div className="ide_bar_link mx-5 dark:text-white">
							স্বাস্থ্য উপদেশ
						</div>
					</Link>
					<Link
						className={`link flex items-center rounded-sm text-xl ${
							location.pathname === "/record"
								? "bg-slate-200 dark:bg-black"
								: ""
						} hover:bg-slate-300 dark:hover:bg-black`}
						to="/records"
						onClick={(event) => {
							event.preventDefault(); // Prevent immediate navigation

							if (location.pathname === "/records") return; // If already on the page, do nothing
							setLoading(true); // Set loading state

							// Navigate manually after the function executes
							navigate("/records");
						}}
					>
						<FolderCopy
							className="dark:fill-white"
							fontSize="medium"
						/>
						<div className="ide_bar_link mx-5 dark:text-white">
							আমার ব্যাবস্থাপত্র
						</div>
					</Link>
					<Link
						className={`link flex items-center rounded-sm text-xl ${
							location.pathname === "/appt_requests"
								? "bg-slate-200 dark:bg-black"
								: ""
						} hover:bg-slate-300 dark:hover:bg-black`}
						to="/upload"
						// onClick={(event) => {
						// 	event.preventDefault(); // Prevent immediate navigation

						// 	if (location.pathname === "/upload") return; // If already on the page, do nothing
						// 	setLoading(true); // Set loading state

						// 	// Navigate manually after the function executes
						// 	navigate("/upload");
						// }}
					>
						<Upload className="dark:fill-white" fontSize="medium" />
						<div className="ide_bar_link mx-5 dark:text-white">
							আপ্লোড করুন
						</div>
					</Link>
					<Link
						className={`link flex items-center rounded-sm text-xl ${
							location.pathname === "/appt_requests"
								? "bg-slate-200 dark:bg-black"
								: ""
						} hover:bg-slate-300 dark:hover:bg-black`}
						to="/uploaded_records"
						onClick={(event) => {
							event.preventDefault(); // Prevent immediate navigation

							if (location.pathname === "/uploaded_records")
								return; // If already on the page, do nothing
							// setLoading(true); // Set loading state

							// Navigate manually after the function executes
							navigate("/uploaded_records");
						}}
					>
						<Image className="dark:fill-white" fontSize="medium" />
						<div className="ide_bar_link mx-5 dark:text-white">
							ব্যাবস্থাপত্রের ছবি
						</div>
					</Link>
					{/*<Link
						className={`link flex items-center rounded-sm text-xl ${
							location.pathname === "/funds"
								? "bg-slate-200 dark:bg-black"
								: ""
						} hover:bg-slate-300 dark:hover:bg-black`}
						to="/funds"
					>
						<AttachMoneyIcon
							className="dark:fill-white"
							fontSize="medium"
						/>
						<div className="ide_bar_link mx-5 dark:text-white">
							জরুরী পরিষেবা
						</div>
					</Link>
					<Link
						className={`link flex items-center rounded-sm text-xl ${
							location.pathname === "/stats"
								? "bg-slate-200 dark:bg-black"
								: ""
						} hover:bg-slate-300 dark:hover:bg-black`}
						to="/stats"
					>
						<BarChartIcon
							className="dark:fill-white"
							fontSize="medium"
						/>
						<div className="ide_bar_link mx-5 dark:text-white">
							শ্বাসযন্ত্রের স্বাস্থ্য
						</div>
					</Link> */}
					<Link
						className={`link flex items-center rounded-sm text-xl ${
							location.pathname === "/support"
								? "bg-slate-200 dark:bg-black"
								: ""
						} hover:bg-slate-300 dark:hover:bg-black`}
						to="/support"
					>
						<SupportAgentIcon
							className="dark:fill-white"
							fontSize="medium"
						/>
						<div className="ide_bar_link mx-5 dark:text-white">
							সাহায্য
						</div>
					</Link>
				</div>
				{/* <div className="whoami flex-col absolute bottom-0 link">
					<div className="name_dept flex font-bold">
						<div className="name">
							{user?.name ? `${user.name}, ${user.dept}` : "User"}
						</div>
					</div>
					<div
						className="logout flex justify-center items-center text-lg cursor-pointer"
						onClick={handleLogout}
					>
						<LogoutIcon fontSize="medium" />
						<div className="label ml-3">Log out</div>
					</div>
				</div> */}
			</div>
		</Box>
	);

	return (
		<navbar
			// className="navbar border-0 shadow-lg bg-white dark:bg-black dark:shadow-slate-800/80 fixed w-full top-0 z-50 flex items-center justify-content !p-4 dark:border-0"
			className="fixed top-0 z-50 flex items-center justify-content !p-4 bg-gray-50 h-16 flex-row justify-between w-full border-b-2"
		>
			<Box className="flex items-center gap-2">
				{auth.isAuthenticated && (
					<React.Fragment key={"left"}>
						<Button
							onClick={toggleDrawer("left", true)}
							startIcon={<MenuIcon />}
							variant="outlined"
						>
							<span className="text-sm font-medium">মেনু</span>
						</Button>
						<Drawer
							anchor={"left"}
							open={state["left"]}
							onClose={toggleDrawer("left", false)}
						>
							{list("left")}
						</Drawer>
					</React.Fragment>
				)}

				<h1
					className="text-3xl flex items-center alkatra-700 text-zinc-700 flex-row gap-2 cursor-pointer hover:text-black transition-colors duration-300"
					onClick={() => navigate("/")}
				>
					<LocalHospital fontSize="large" />
					মুক্তি
				</h1>
			</Box>

			{/* <button onClick={handleTheme} className="flex items-center">
				<WbSunnyIcon className="absolute h-8 right-5 rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
				<DarkModeIcon className="absolute h-8 right-5 rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100 dark:fill-white" />
				<span className="sr-only">Toggle theme</span>
			</button> */}
			{auth.isAuthenticated ? (
				<Box className="flex flex-row gap-4 items-center">
					{/* <LoadingButton
						className="font-semibold flex-row items-center gap-3 rounded-lg text-lg px-7 py-2 text-center bu-button-primary hidden md:flex"
						variant="outlined"
						loading={auth.isLoading}
						loadingPosition="end"
						endIcon={
							<FontAwesomeIcon
								className="!p-0"
								icon={faRightFromBracket}
							/>
						}
						onClick={signOutRedirect}
					>
						<h1 className="align-middle text-lg hidden md:block">
							লগআউট
						</h1>
					</LoadingButton> */}
					{/* <Tooltip title="Account settings"> */}
					<IconButton
						onClick={handleClick}
						size="small"
						sx={{ ml: 2 }}
						aria-controls={open ? "account-menu" : undefined}
						aria-haspopup="true"
						aria-expanded={open ? "true" : undefined}
					>
						<Avatar sx={{ width: 32, height: 32 }}>M</Avatar>
					</IconButton>
					{/* </Tooltip> */}
					{/* <Avatar
						size="small"
						alt="blah"
						src={user != null ? user.image : "/avatar.jpg"}
						className="cursor-pointer border-2 hover:border-gray-500 transition-colors duration-300"
						onClick={handleClick}
						// onClick={() => {
						//   setLoading(true);
						//   type == 0
						//     ? navigate("/user/" + user.username)
						//     : navigate("/setter/" + user.username);
						// }}
						id="demo-positioned-button"
						aria-controls={
							open ? "demo-positioned-menu" : undefined
						}
						aria-haspopup="true"
						aria-expanded={open ? "true" : undefined}
					/> */}
					<Menu
						anchorEl={anchorEl}
						id="account-menu"
						open={open}
						onClose={handleClose}
						onClick={handleClose}
						slotProps={{
							paper: {
								elevation: 0,
								sx: {
									overflow: "visible",
									filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
									mt: 1.5,
									"& .MuiAvatar-root": {
										width: 32,
										height: 32,
										ml: -0.5,
										mr: 1,
									},
									"&::before": {
										content: '""',
										display: "block",
										position: "absolute",
										top: 0,
										right: 14,
										width: 10,
										height: 10,
										bgcolor: "background.paper",
										transform:
											"translateY(-50%) rotate(45deg)",
										zIndex: 0,
									},
								},
							},
						}}
						transformOrigin={{
							horizontal: "right",
							vertical: "top",
						}}
						anchorOrigin={{
							horizontal: "right",
							vertical: "bottom",
						}}
					>
						<MenuItem
							onClick={() => {
								if (location.pathname === "/profile") return; // If already on the page, do nothing
								setLoading(true);
								navigate("/profile");
							}}
						>
							<Avatar /> Profile
						</MenuItem>
						<MenuItem onClick={handleClose}>
							<Avatar /> My account
						</MenuItem>
						<Divider />
						<MenuItem onClick={handleClose}>
							<ListItemIcon>
								<PersonAdd fontSize="small" />
							</ListItemIcon>
							Add another account
						</MenuItem>
						<MenuItem onClick={handleClose}>
							<ListItemIcon>
								<Settings fontSize="small" />
							</ListItemIcon>
							Settings
						</MenuItem>
						<MenuItem onClick={signOutRedirect}>
							<ListItemIcon>
								<Logout fontSize="small" />
							</ListItemIcon>
							Logout
						</MenuItem>
					</Menu>
				</Box>
			) : (
				<Tooltip
					title="পরামর্শ সংরক্ষণ করতে এবং আপনার প্রেসক্রিপশন আপলোড করতে লগইন করুন।"
					placement="bottom"
					arrow
					open={tooltipOpen} // Always visible
				>
					<LoadingButton
						className="font-semibold flex-row items-center gap-3 rounded-lg text-lg px-7 py-2 text-center bu-button-primary hidden md:flex"
						// onClick={() => {
						// 	document.body.style.cursor = "default";
						// 	navigate("/login");
						// }}
						variant="outlined"
						loading={auth.isLoading}
						loadingPosition="start"
						startIcon={<FontAwesomeIcon icon={faRightToBracket} />}
						onClick={auth.signinRedirect}
					>
						<h1 className="align-middle text-lg">লগইন</h1>
					</LoadingButton>
				</Tooltip>
			)}
		</navbar>
	);
};

export default NavBar;
